@if (visible) {
<div class="modal fade show d-block validation-modal-backdrop" tabindex="-1" role="dialog" aria-modal="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content border-0 shadow-lg rounded-4">
      <div class="modal-body p-4">
        <div class="d-flex align-items-center gap-3 mb-3">
          <div class="validation-icon">
            <i class="bi bi-exclamation-triangle-fill"></i>
          </div>
          <div>
            <h4 class="fw-semibold mb-1">{{ title }}</h4>
            <p class="text-muted mb-0">{{ message }}</p>
          </div>
        </div>

        <div class="validation-list">
          <ul class="mb-0">
            @for (item of items; track item) {
            <li>{{ item }}</li>
            }
          </ul>
        </div>

        <div class="d-flex justify-content-end mt-4">
          <button type="button" class="btn btn-primary px-4" (click)="close()">
            Entendido
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
}
